import { useState } from "react"
import { MenuIcon } from "lucide-react"

import { Sheet, SheetContent, SheetTrigger } from "@f2e/ui/components/base"

import { SidebarNav, SidebarNavItem } from "./SidebarNav"

interface MobileSidebarProps {
  items: SidebarNavItem[]
}

export function MobileSidebar({ items }: MobileSidebarProps) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <MenuIcon />
        </SheetTrigger>
        <SheetContent side="left" className="px-0!">
          <div className="space-y-4 py-4">
            <div className="px-3 py-2">
              <h2 className="mb-2 px-4 text-lg font-semibold tracking-tight">
                Overview
              </h2>
              <div className="space-y-1">
                <SidebarNav items={items} />
              </div>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </>
  )
}

export default MobileSidebar
